export default __webpack_public_path__ + "images/87337177b796f88d6083b436d0389826-2_mobile_659x494.webp";